const cctvTechnicianService = {
  title: "CCTV Technician",
  icon: "📹",
  shortDescription:
    "CCTV installation, camera adjustment, DVR check, wiring support, and maintenance.",
  longDescription:
    "Book CCTV support for camera fitting, check-up, wiring corrections, and system review.",
  consultationNote:
    "Fresh installation, wiring route planning, and multi-camera setups may need inspection.",
  responsePromise:
    "Assignment depends on setup size, wiring scope, and technician fit.",
  warrantyPolicy:
    "Support depends on device condition, access, and scope of intervention.",
  subServices: [
    {
      id: "cctv-camera-install",
      title: "Camera Installation",
      icon: "📷",
      group: "Installation",
      description:
        "Install camera unit with basic mounting and connection check.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "45-90 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "cctv-camera-adjustment",
      title: "Camera Adjustment / Reposition",
      icon: "🎯",
      group: "Maintenance",
      description:
        "Adjust field of view, position, or loose mount issue in camera setup.",
      basePrice: 299,
      priceType: "fixed",
      duration: "20-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "cctv-dvr-check",
      title: "DVR / Recording Check",
      icon: "💽",
      group: "System Check",
      description:
        "Inspect recording, storage, feed issue, or basic DVR/NVR functionality problem.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "cctv-inspection",
      title: "CCTV Installation Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for new CCTV plan, multi-camera estimate, or wiring route assessment.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default cctvTechnicianService;